import { render, staticRenderFns } from "./OfficerOpenRecruitmentApplyCreate.vue?vue&type=template&id=0953b32e&"
import script from "./OfficerOpenRecruitmentApplyCreate.vue?vue&type=script&lang=js&"
export * from "./OfficerOpenRecruitmentApplyCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports